import { render, staticRenderFns } from "./test-active-code.vue?vue&type=template&id=6eb6f96e&"
import script from "./test-active-code.vue?vue&type=script&lang=ts&"
export * from "./test-active-code.vue?vue&type=script&lang=ts&"
import style0 from "./test-active-code.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports